<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="Label pola"
			aria-label="field label"
			for="permanent-text-field-props-label"
			id="permanent-text-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-textarea
			browser-autocomplete="off"
			label="Wartość pola"
			aria-label="field value"
			for="permanent-text-field-props-field-value"
			id="permanent-text-field-props-field-value"
			v-model="fieldProps.value"
			class="text-xs-center"
			auto-grow
			outline>
		</v-textarea>
		<v-expand-transition>
			<div v-show="fieldProps.value.length > 32767" style="color: red; display: flex; justify-content: center;" class="ml-3 mr-3">
				Maksymalna liczba znaków nie może przekroczyć 32767.
			</div>
		</v-expand-transition>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "permanentTextFieldsProps",

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
		},

		props: {
			value: Object,
		},

		data() {
			return {
				fieldProps: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
